import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API_URL, AUTH_URL, CHAT_URL, OCR_URL } from "../../utils/constants";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import SendIcon from "@mui/icons-material/Send";
import { Snackbar } from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ThreeDotsLoader } from "../commonComponent/loader";
import MicIcon from "@mui/icons-material/Mic";
import SettingsVoiceIcon from "@mui/icons-material/SettingsVoice";
import BotHeader from "./BotHeader";
import picLogo from "../../assets/images/circular_logo.svg";
import bgImage from "../../assets/images/background1.png";
import voiceAssistantGif from "../../assets/images/voice_assis.gif";
import botLogo from "../../assets/images/bot.png";
import micIconPng from "../../assets/images/Icon.png";
import uploadIconPng from "../../assets/images/Icon (1).png";
import sendButtonPng from "../../assets/images/Button.png";
import largeMicButtonPng from "../../assets/images/mic button.png";
import vectorPng from "../../assets/images/Vector.png";
import Avatar from "@mui/material/Avatar";
import Translation from "../commonComponent/Language/language";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ScreenLoader from "../commonComponent/freezeScreenLoader";
import Swal from "sweetalert2";
import { useAuth } from "../../utils/AuthContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";

const generateUniqueNumber = () => {
  const min = 1000000000; // Smallest 10-digit number
  const max = 9999999999; // Largest 10-digit number
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
const bars = [
  { height: "h-1", delay: 0 },
  { height: "h-2", delay: 0.2 },
  { height: "h-1", delay: 0.4 },
  { height: "h-2", delay: 0.5 },
  { height: "h-1", delay: 0.6 },
];
const FAQ = () => {
  // const userId = user.userId;//sessionStorage.getItem("userId");
  const paragraphRef = useRef(null);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);
  const [copyBar, setCopyBar] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [chatbotInput, setChatbotInput] = useState([]);
  const [chatbotOutput, setChatbotOutput] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [audioBase64, setAudioBase64] = useState("");
  const [selectedLanguageCode, setSelectedLanguageCode] = useState("en");
  const [uniqueNumber, setUniqueNumber] = useState(generateUniqueNumber);
  const [textOutput, setTextOutput] = useState("");
  const [audioLoading, setAudioLoading] = useState(false);
  const [isListOpen, setIsListOpen] = useState(false);
  const [outputIndex, setOutputIndex] = useState(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [currentWord, setCurrentWord] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [fileContent, setFileContent] = useState("");
  const [feedback, setFeedback] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { user } = useAuth();
  const recognitionRef = useRef(null);
  const submitTimeoutRef = useRef(null);
  const isSearchSubmittedRef = useRef(false);

  const suggestedQuestions = [
    {
      id: 1,
      question: "What is CAG?",
    },
    {
      id: 2,
      question: "What powers does the CAG have?",
    },
    {
      id: 3,
      question: "How does CAG perform his role?",
    },
  ];
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) return;

    const recognition = new SpeechRecognition();

    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.onstart = () => {
      isSearchSubmittedRef.current = false;
      setIsListening(true);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onresult = (event) => {
      if (isSearchSubmittedRef.current) return;
      let transcript = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        transcript += event.results[i][0].transcript;
      }

      setSearchText(transcript);
      clearTimeout(submitTimeoutRef.current);

      submitTimeoutRef.current = setTimeout(() => {
        if (transcript.trim()) {
          isSearchSubmittedRef.current = true;
          handleSearch(transcript);
          recognition.abort();
        }
      }, 4000);
    };

    recognitionRef.current = recognition;
    return () => {
      clearTimeout(submitTimeoutRef.current);
      recognition.stop();
    };
  }, []);

  const handleMicClick = () => {
    const recognition = recognitionRef.current;
    if (!recognition) return;
    recognition.lang = selectedLanguageCode === "hi" ? "hi-IN" : "en-US";
    if (isListening) {
      recognitionRef.current?.stop();
      // stopListening();
    } else {
      recognitionRef.current?.start();
      // startListening();
    }
  };

  let audioChunks = [];

  const closePopup = () => setIsPopupOpen(false);

  const handleFeedbackChange = (e) => setFeedback(e.target.value);

  const handleLanuageClick = (code) => {
    setSelectedLanguageCode(code);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // setFileLoading(true);
    console.log("Selected file:", file.name);
    setFileContent(file);
    // const formData = new FormData();
    // formData.append("uploaded_file", file);

    // try {
    //   const response = await axios.post(
    //     `${API_URL}v1/upload_file`,
    //     formData,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }
    //   );
    //   if (response?.data) {
    //     setTextOutput(response?.data.result);
    //   }
    //   console.log("Upload success:", response.data);
    // } catch (error) {
    //   console.error("Upload failed:", error);
    // } finally {
    //   setFileLoading(false);
    // }
    event.target.value = "";
  };

  const togglePopup = (index) => {
    setOutputIndex(index);
    setIsListOpen(!isListOpen);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const regenerateNumber = () => {
    setUniqueNumber(generateUniqueNumber());
  };

  useEffect(() => {
    if (fileContent) {
      handleSearch();
    }
  }, [fileContent]);

  const handleSearch = async (input) => {
    clearTimeout(submitTimeoutRef.current);
    recognitionRef.current?.stop();
    const text = typeof input === "string" ? input : searchText;
    stopListening();
    let arr = chatbotInput;
    let inputText = "";

    if (fileContent) {
      inputText = `${fileContent.name} file has been uploaded`;
    } else if (text) {
      inputText = text;
    }

    arr.push(inputText || arr[arr.length - 1]);
    setChatbotInput(arr);
    setSearchText("");
    setShowSuggestions(false);
    setLoading(true);

    try {
      let config = {
        headers: {
          "X-Request-ID": user?.userId || "",
          "x-source": uniqueNumber,
          "x-consumer-id": 1,
        },
      };

      let body;
      let endpoint;

      if (fileContent) {
        endpoint = "v1/upload_file";
        const formData = new FormData();
        formData.append("uploaded_file", fileContent);
        formData.append(
          "input",
          JSON.stringify({
            language: selectedLanguageCode,
            text: "",
            audio: "",
            context: "JB_system_prompt",
          }),
        );
        formData.append(
          "output",
          JSON.stringify({
            format: "text",
          }),
        );

        config.headers["Content-Type"] = "multipart/form-data";
        body = formData;
      } else {
        // For text input only, use pure JSON body
        endpoint = "v1/cag_chat";
        config.headers["Content-Type"] = "application/json";
        // config.headers["USER-ID"] = user?.userId || "";
        body = {
          input: {
            language: selectedLanguageCode,
            text: text || arr[arr.length - 1],
            audio: "",
            context: "JB_system_prompt",
          },
          output: {
            format: "text",
          },
        };
      }

      const res = await axios.post(`${CHAT_URL}${endpoint}`, body, config);

      if (res?.data) {
        let outputArr = chatbotOutput;
        outputArr.push({
          ...res.data,
          isFileUpload: !!fileContent,
          selectedBucket: {
            ...res.data?.grievance_bucket?.bucket1,
            State: res.data?.state,
            Office_Area: res.data?.office_area,
            Department: res.data?.department_name,
          },
        });

        // if (res?.data.mandatory_data_present) {
        //   regenerateNumber();
        // }

        setChatbotOutput(outputArr);
        if (fileContent) {
          // setTextOutput(res?.data?.response);
          setTextOutput("Test response");
        } else {
          setTextOutput(res?.data?.Regional_Response);
        }
        setLoading(false);
      } else {
        setLoading(false);
        let outputArr = chatbotOutput;
        outputArr.push({
          Regional_Response:
            Translation[selectedLanguageCode]?.apiErrorMessage ||
            "Sorry I cannot understand, please reframe the message.",
        });
        setChatbotOutput(outputArr);
      }
    } catch (error) {
      console.log("there is some error", error);
      setLoading(false);
      let outputArr = chatbotOutput;

      if (error.code === "ERR_NETWORK") {
        outputArr.push({
          Regional_Response:
            "The server is taking too long to respond. Please try again later.",
        });
      } else {
        outputArr.push({
          Regional_Response: "An error occurred while fetching data.",
        });
      }

      setChatbotOutput(outputArr);
    } finally {
      setFileContent("");
    }
  };

  useEffect(() => {
    const audioCall = async () => {
      setAudioLoading(true);
      try {
        let res = await axios.post(
          `${API_URL}process_audio`,
          {
            regional_answer: textOutput,
            language: selectedLanguageCode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (res?.data) {
          let outputArray = chatbotOutput;
          outputArray[outputArray.length - 1].audio_base64 =
            res?.data?.audio_base64;
          setChatbotOutput(outputArray);
          setTextOutput("");
        }
      } catch (error) {
        console.log("Error in generating audio", error);
      } finally {
        setAudioLoading(false);
      }
    };
    if (selectedLanguageCode && textOutput) {
      audioCall();
    }
  }, [textOutput, selectedLanguageCode]);

  const handleCopy = (text) => {
    navigator.clipboard?.writeText(text);
    setCopyBar(false);
  };

  const handleEdit = (text) => {
    inputRef.current?.focus();
    setSearchText(text);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setCopyBar(false);
  };

  const handleRegenerate = () => {
    handleSearch();
  };

  const startListening = async () => {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setSearchText(
          "Microphone access requires a secure connection (HTTPS) or is not supported by your browser.",
        );
        return;
      }
      setSearchText("Recording is in progress...");
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);

      mediaRecorderRef.current.ondataavailable = (event) => {
        audioChunks.push(event.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
        const reader = new FileReader();

        reader.onloadend = () => {
          const base64Audio = reader.result?.split(",")[1];
          setAudioBase64(base64Audio);
        };

        reader.readAsDataURL(audioBlob);
        audioChunks = []; // Clear the chunks for the next recording
      };

      mediaRecorderRef.current.start();
      setIsListening(true);
      console.log("Recording started...");
    } catch (error) {
      console.error("Error accessing the microphone:", error);
      setSearchText(
        "Error accessing microphone. Please ensure permissions are granted.",
      );
      setIsListening(false);
    }
  };

  const stopListening = () => {
    if (mediaRecorderRef.current) {
      setSearchText("Recording stopped. Please wait for a moment.");
      mediaRecorderRef.current.stop();
      setIsListening(false);
      console.log("Recording stopped.");
      // Clean up any remaining resources
      mediaRecorderRef.current.stream
        .getTracks()
        .forEach((track) => track.stop());
      mediaRecorderRef.current = null; // Clear reference
    }
  };

  useEffect(() => {
    const audioToText = async () => {
      try {
        let res = await axios.post(
          `${API_URL}speech2text`,
          {
            audio: audioBase64,
            source_language: selectedLanguageCode || "en",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (res?.data) {
          console.log(res?.data, "line218");
          setSearchText(res?.data?.output);
        }
      } catch (error) {
        console.log("there is audio error", error);
      }
    };
    if (audioBase64) {
      audioToText();
    }
  }, [audioBase64]);

  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
    };
  }, []);

  useEffect(() => {
    if (chatbotInput.length) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [chatbotInput.length, chatbotOutput.length]);

  const handleSuggestionClick = (text) => {
    setSearchText(text);
  };

  const fetchSuggestions = async (text) => {
    if (!text) {
      setSuggestions([]);
      return;
    }
    try {
      let res = await axios.post(
        `${API_URL}v1/transliterate`,
        {
          pipelineTasks: [
            {
              taskType: "transliteration",
              config: {
                language: {
                  sourceLanguage: "en",
                  targetLanguage: selectedLanguageCode,
                },
                serviceId: "ai4bharat/indicxlit--cpu-fsv2",
                isSentence: false,
                numSuggestions: 4,
              },
            },
          ],
          inputData: {
            input: [
              {
                source: text,
              },
            ],
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (res?.data) {
        console.log(res?.data, "line218");
        let resultText = res.data?.pipelineResponse[0]?.output[0]?.target;
        setSuggestions(resultText);
      }
    } catch (error) {
      console.log("there is transliteration error", error);
    }
  };

  useEffect(() => {
    if (!currentWord) {
      setShowSuggestions(false);
      return;
    }
    if (selectedLanguageCode !== "en") {
      const debounce = setTimeout(() => {
        fetchSuggestions(currentWord);
      }, 500); // Debounce for 300ms

      return () => clearTimeout(debounce);
    }
  }, [currentWord]);

  const handleInputChange = (e) => {
    clearTimeout(submitTimeoutRef.current);
    recognitionRef.current?.stop();
    const value = e.target.value;
    setSearchText(value);

    // Extract the current word being typed
    const words = value?.split(" ");
    const lastWord = words[words.length - 1];
    setCurrentWord(lastWord);
    setShowSuggestions(true);
  };

  const handleTranslationClick = (suggestion) => {
    const words = searchText?.split(" ");
    words[words.length - 1] = suggestion; // Replace the current word with the suggestion
    const updatedText = words.join(" ");
    setSearchText(updatedText); // Update the search bar text
    setCurrentWord(""); // Clear the current word
    setShowSuggestions(false);
  };

  const handleSelectedBucket = (value) => {
    let outputArray = chatbotOutput;
    outputArray[outputIndex].selectedBucket = {
      ...outputArray[outputIndex].selectedBucket,
      ...value,
    };
    setChatbotOutput(outputArray);
    setIsListOpen(!isListOpen);
  };

  const handleLikeDislike = (i, value) => {
    const updatedOutputArray = [...chatbotOutput];
    updatedOutputArray[i] = { ...updatedOutputArray[i], userFeedback: value };
    setChatbotOutput(updatedOutputArray);
    if (value === "Disliked") {
      setIsPopupOpen(true);
    }
  };

  const handleSubmit = async (index) => {
    setSubmitLoading(true);
    console.log("chatbotOutput", chatbotOutput[index]);
    try {
      let res = await axios.post(
        `${AUTH_URL}api/create_query`,
        {
          Session_id: uniqueNumber,
          user_id: user.userId,
          user_query: chatbotInput[0],
          user_query_language_code: selectedLanguageCode,
          user_query_english: chatbotInput[0],
          llm_response_desc: chatbotOutput[index]?.Regional_Response,
          llm_ministry: chatbotOutput[index]?.selectedBucket?.Ministry || "",
          llm_category: chatbotOutput[index]?.selectedBucket?.Category,
          llm_subcategory:
            chatbotOutput[index]?.selectedBucket?.["Sub-Category"],
          severity: chatbotOutput[index]?.Priority || "High", // need to be update
          user_feedback: chatbotOutput[index]?.userFeedback || "",
          city: chatbotOutput[index]?.selectedBucket?.office_area || "",
          district:
            chatbotOutput[index]?.selectedBucket?.District ||
            chatbotOutput[index]?.district ||
            "",
          query_feedbacktext: feedback || "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (res.status === 201) {
        setChatbotInput([]);
        setChatbotOutput([]);
        setFeedback("");
        Swal.fire({
          title: "Query Submitted!",
          text: "You have successfully submitted. Click on below button to see your query status.",
          icon: "success",
          footer: '<a href="/desk">Go to Dashboard</a>',
        });
      }
    } catch (error) {
      console.log("Error in Create Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error in Create Query API",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <div className="flex-1 min-w-0 h-full relative flex flex-col shadow-md bg-[#ecf0fb] ">
        <Snackbar
          open={copyBar}
          autoHideDuration={5000}
          onClose={handleClose}
          message="text is copied."
          sx={{ width: "100%" }}
        />
        <BotHeader
          handleLanuageClick={handleLanuageClick}
          information={
            Translation[selectedLanguageCode]?.faqScroller ||
            "This assistant helps answer questions and provides guidance related to CAG services."
          }
        />
        <div
          className={`relative w-full flex-1 bg-cover bg-center z-0 ${chatbotInput?.length > 0 ? 'overflow-y-auto' : 'overflow-hidden'}`}
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "130% 130%",
            backgroundPosition: "right bottom",
          }}
        >
          <div className="relative z-10 min-h-full pb-36">
            {chatbotInput?.length === 0 && (
              <div className="flex flex-col items-center mt-8 h-full py-2 gap-4">
                {/* Header Section */}
                <div className="text-center flex flex-col items-center justify-center gap-4">
                  <div className="flex items-center justify-center w-[140px] h-[140px] rounded-full border-2 transition-all duration-300 bg-[#E8F2FA] border-[#E0E0E0]">
                    <div className="bg-[#FF8020] w-[115px] h-[115px] rounded-full shadow-lg flex items-center justify-center">
                      <div
                        className="w-[90px] h-[90px] rounded-full bg-white shadow-lg transition-all duration-300 cursor-pointer flex items-center justify-center"
                        onClick={handleMicClick}
                      >
                        {isListening ? (
                          <motion.div
                            animate={{ scale: [1, 1.1, 1] }}
                            transition={{ duration: 0.6, repeat: Infinity }}
                          >
                            <img src={voiceAssistantGif} alt="Recording" className="w-[84px] h-[84px] object-contain rounded-full" />
                          </motion.div>
                        ) : (
                          <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.3 }}
                            className="flex flex-col items-center justify-center pt-2"
                          >
                            <img src={vectorPng} alt="Mic Icon" className="w-[30px] h-[30px] object-contain" />
                            <div className="flex gap-1 mt-2">
                              {bars.map((bar, i) => (
                                <motion.div
                                  key={`${bar.height}-${bar.delay}`}
                                  className={`w-1 bg-gray-500 rounded ${bar.height}`}
                                  animate={{
                                    scaleY: [1, 1.8, 1],
                                    opacity: [0.5, 1, 0.5],
                                  }}
                                  transition={{
                                    duration: 0.8,
                                    repeat: Infinity,
                                    repeatType: "loop",
                                    delay: bar.delay,
                                  }}
                                  style={{ transformOrigin: "bottom" }}
                                />
                              ))}
                            </div>
                          </motion.div>
                        )}
                      </div>
                    </div>
                  </div>
                  <h1 className="text-[18px] font-semibold mt-3">
                    {Translation[selectedLanguageCode]?.faqTitle ||
                      "Ask your query"}
                  </h1>
                </div>

                {/* Suggested Questions Section */}
                {/* <div className="mt-5 bg-white shadow-md rounded-lg p-3 w-full max-w-md">
                  <h2 className=" font-semibold text-center text-[#247087] ">
                    {Translation[selectedLanguageCode]
                      ?.suggestedQuestionsText || "Suggested Questions"}
                  </h2>
                  <ul className="mt-4 space-y-2 text-sm ">
                    <li
                      className="bg-gray-100 border border-gray-200 hover:bg-gray-200 p-2 rounded-lg shadow-sm"
                      onClick={() =>
                        handleSuggestionClick(
                          Translation[selectedLanguageCode]
                            ?.suggestedFAQs[0]
                        )
                      }
                    >
                      <button className="text-left text-black w-full ">
                        {Translation[selectedLanguageCode]
                          ?.suggestedFAQs[0] ||
                          "What is CAG?"}
                      </button>
                    </li>
                    <li
                      className="bg-gray-100 border border-gray-200 hover:bg-gray-200 p-2 rounded-lg shadow-sm"
                      onClick={() =>
                        handleSuggestionClick(
                          Translation[selectedLanguageCode]
                            ?.suggestedFAQs[1]
                        )
                      }
                    >
                      <button className="text-left text-black w-full ">
                        {Translation[selectedLanguageCode]
                          ?.suggestedFAQs[1] ||
                          "What powers does the CAG have?"}
                      </button>
                    </li>
                    <li
                      className="bg-gray-100 border border-gray-200 hover:bg-gray-200 p-2 rounded-lg shadow-sm"
                      onClick={() =>
                        handleSuggestionClick(
                          Translation[selectedLanguageCode]
                            ?.suggestedFAQs[2]
                        )
                      }
                    >
                      <button className="text-left text-black w-full ">
                        {Translation[selectedLanguageCode]
                          ?.suggestedFAQs[2] ||
                          "How does CAG perform his role?"}
                      </button>
                    </li>
                  </ul>
                </div> */}
                <div className="flex justify-center items-center  bg-white/70 rounded-xl p-2  w-[40%] max-w-[450px] mt-3">
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    loop
                    className="w-full min-h-[60px]"
                  >
                    {suggestedQuestions.map((question) => (
                      <SwiperSlide key={question.id}>
                        <div className="flex items-center justify-center h-full  cursor-pointer">
                          <p
                            className="text-sm text-gray-800 text-center"
                            onClick={() =>
                              handleSuggestionClick(question.question)
                            }
                          >
                            {question.question}
                          </p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            )}
            {chatbotInput?.length > 0 &&
              chatbotInput.map((item, index) => {
                return (
                  <>
                    <div
                      key={index}
                      className="flex justify-end gap-x-3 mx-5 my-5 "
                      ref={paragraphRef}
                    >
                      <div className="border border-[#FFD6A8] shadow-[0_8px_10px_-6px_rgba(0,0,0,0.1),_0_20px_25px_-5px_rgba(0,0,0,0.1),_0_0_0_2px_rgba(255,184,106,0.5)] bg-[#FFF7EC] text-black rounded-l-lg rounded-br-lg px-5 py-1 max-w-[90%]">
                        <div className="flex gap-3 my-1 text-black flex-1">
                          <div className="leading-relaxed">
                            <span className="text-[#F16D01] text-sm font-medium">{item}</span>

                            <div className="mt-2 flex gap-x-1 ">
                              <CopyToClipboard
                                text={item}
                                onCopy={() => handleCopy(item)}
                              >
                                <svg
                                  className="h-5 w-5 cursor-pointer"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="#FE6700"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  {" "}
                                  <path stroke="none" d="M0 0h24v24H0z" />{" "}
                                  <rect
                                    x="8"
                                    y="8"
                                    width="12"
                                    height="12"
                                    rx="2"
                                  />{" "}
                                  <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                                </svg>
                              </CopyToClipboard>
                              <svg
                                className="h-5 w-5 cursor-pointer"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="#FE6700"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                onClick={() => handleEdit(item)}
                              >
                                {" "}
                                <path stroke="none" d="M0 0h24v24H0z" />{" "}
                                <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />{" "}
                                <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />{" "}
                                <line x1="16" y1="5" x2="19" y2="8" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="relative flex shrink-0 items-center justify-center rounded-[16px] w-[44px] h-[44px] bg-gradient-to-br from-[#FE6700] to-[#F1BC81]">
                        <img
                          src={picLogo}
                          alt="pic logo"
                          className="w-[24px] h-[24px] invert"
                        />
                      </div>
                    </div>
                    {chatbotOutput?.length > 0 && chatbotOutput[index] && (
                      <div className="flex gap-x-3 text-left mx-5 my-5 max-w-[80%] ">
                        <div className="relative flex shrink-0 items-center justify-center rounded-[16px] w-[44px] h-[44px] border-[2px] border-white bg-gradient-to-br from-[#FF8904] to-[#F54900]">
                          <img
                            src={botLogo}
                            alt="bot logo"
                            className="w-[24px] h-[24px] invert"
                          />
                        </div>
                        <div className="border-[1.6px] border-[#FFD6A8] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] bg-[#FFFFFF] rounded-tl-[8px] rounded-tr-[24px] rounded-br-[24px] rounded-bl-[24px] flex flex-col justify-center items-center">
                          <div className="flex gap-3 px-4 my-2 w-[100%] text-black text-sm flex-1">
                            <div className="leading-relaxed">
                              <div className="text-sm font-normal">
                                {/* {!chatbotOutput[index]
                                  ?.mandatory_data_present &&
                                  chatbotOutput[index]?.text} */}
                                {
                                  <div className="w-full bg-gray-100 shadow-lg rounded-lg p-4">
                                    <h2 className="text-lg font-bold font-hanken text-[#E17100] mb-2">
                                      Response
                                    </h2>
                                    <div className="mb-1">
                                      <div className="prose max-w-none font-hanken font-medium text-[15px] leading-[28px] text-[#4D4646]/80 overflow-x-auto">
                                        <ReactMarkdown
                                          remarkPlugins={[
                                            remarkGfm,
                                            remarkBreaks,
                                          ]}
                                          components={{
                                            p: ({ node, ...props }) => (
                                              <p
                                                className="mb-2 last:mb-0 font-hanken font-medium text-[15px] leading-[28px] text-[#4D4646]/80"
                                                {...props}
                                              />
                                            ),
                                            ul: ({ node, ...props }) => (
                                              <ul
                                                className="list-disc ml-5 mb-2"
                                                {...props}
                                              />
                                            ),
                                            ol: ({ node, ...props }) => (
                                              <ol
                                                className="list-decimal ml-5 mb-2"
                                                {...props}
                                              />
                                            ),
                                            li: ({ node, ...props }) => (
                                              <li className="mb-1" {...props} />
                                            ),
                                          }}
                                        >
                                          {(
                                            chatbotOutput[index]?.output
                                              ?.text ||
                                            chatbotOutput[index]
                                              ?.Regional_Response ||
                                            chatbotOutput[index]?.response ||
                                            chatbotOutput[index]?.text ||
                                            ""
                                          ).trim()}
                                        </ReactMarkdown>
                                      </div>
                                    </div>
                                    {/* <div className="mb-4">
                                        <h3 className="text-lg font-semibold text-gray-800">
                                          Grievance Details:
                                        </h3>
                                        {chatbotOutput[index]?.selectedBucket && (
                                          <table className="min-w-full mt-2 border-collapse border border-gray-300">
                                            <tbody>
                                              {Object.entries(
                                                chatbotOutput[index]
                                                  ?.selectedBucket
                                              ).map(([key, value], index) => (
                                                <tr
                                                  key={index}
                                                  className={
                                                    index % 2 === 0
                                                      ? "bg-[#d1d8dc]"
                                                      : "bg-[white]"
                                                  }
                                                >
                                                  <td className="border border-gray-400 px-4 py-2 font-medium text-gray-800">
                                                    {key}
                                                  </td>
                                                  <td className="border border-gray-400 px-4 py-2 text-gray-800">
                                                    {typeof value === "object"
                                                      ? JSON.stringify(value)
                                                      : value}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        )}
                                      </div> */}
                                    {/* <button
                                        className=" mb-2 px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 focus:outline-none"
                                        onClick={() => togglePopup(index)}
                                      >
                                        Change Grievance Category
                                      </button> */}
                                    {/* <div className="mb-4">
                                        <p className="text-gray-800 font-semibold">
                                          {chatbotOutput[index]?.user_experience}
                                        </p>
                                      </div> */}
                                    {/* <div className="flex gap-x-2">
                                        {!chatbotOutput[index]?.userFeedback && (
                                          <>
                                            <button
                                              className="px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 focus:outline-none"
                                              onClick={() =>
                                                handleLikeDislike(index, "Liked")
                                              }
                                            >
                                              👍 Like
                                            </button>
                                            <button
                                              className="px-4 py-2 bg-red-500 text-white rounded-lg shadow-md hover:bg-red-600 focus:outline-none"
                                              onClick={() =>
                                                handleLikeDislike(
                                                  index,
                                                  "Disliked"
                                                )
                                              }
                                            >
                                              👎 Dislike
                                            </button>
                                          </>
                                        )}
                                        {chatbotOutput[index]?.userFeedback && (
                                          <button
                                            className={`px-4 py-2 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-600 focus:outline-none ${chatbotOutput[index]
                                              ?.userFeedback === "Liked" &&
                                              "bg-red-500 hover:bg-red-600 "
                                              }`}
                                          >
                                            {chatbotOutput[index]
                                              ?.userFeedback === "Liked"
                                              ? "👍"
                                              : "👎"}{" "}
                                            {chatbotOutput[index]?.userFeedback}
                                          </button>
                                        )}

                                        <button
                                          className="px-4 py-2 bg-green-700 text-white rounded-lg shadow-md hover:bg-green-800 focus:outline-none"
                                          onClick={() => handleSubmit(index)}
                                        >
                                          Submit
                                        </button>
                                      </div> */}
                                  </div>
                                }
                                {chatbotOutput[index]?.isFileUpload &&
                                  chatbotOutput[index]?.summary && (
                                    <div className="mt-3 mb-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                      <h4 className="text-sm font-bold text-blue-800 mb-1">
                                        Summary
                                      </h4>
                                      <p className="text-sm text-blue-900 whitespace-pre-line">
                                        {chatbotOutput[index]?.summary}
                                      </p>
                                    </div>
                                  )}
                                {audioLoading && (
                                  <div className="my-2 flex gap-x-2 items-center">
                                    <ThreeDotsLoader className="animate-pulse" />
                                    Audio is being generated. It may take some
                                    time.
                                  </div>
                                )}
                                {chatbotOutput[index]?.audio_base64 && (
                                  <audio
                                    className="mt-3 mb-2 "
                                    ref={audioRef}
                                    controls
                                  >
                                    <source
                                      src={`data:audio/mp3;base64,${chatbotOutput[index]?.audio_base64}`}
                                      type="audio/mp3"
                                    />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                )}
                              </div>
                              <div className="mt-3 flex gap-x-1 ">
                                <CopyToClipboard
                                  text={chatbotOutput[index]?.text}
                                  onCopy={() =>
                                    handleCopy(chatbotOutput[index]?.text)
                                  }
                                >
                                  <svg
                                    className="h-5 w-5 cursor-pointer"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="#FE6700"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    {" "}
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                    />{" "}
                                    <rect
                                      x="8"
                                      y="8"
                                      width="12"
                                      height="12"
                                      rx="2"
                                    />{" "}
                                    <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                                  </svg>
                                </CopyToClipboard>

                                {index === chatbotInput.length - 1 && (
                                  <svg
                                    className="h-5 w-5 cursor-pointer"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="#FE6700"
                                    onClick={handleRegenerate}
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    />
                                  </svg>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!chatbotOutput[index] && loading && (
                      <div className="flex gap-x-3 text-left mx-5 my-5 max-w-[80%] ">
                        <div className="relative flex shrink-0 items-center justify-center rounded-[16px] w-[44px] h-[44px] border-[2px] border-white bg-gradient-to-br from-[#FF8904] to-[#F54900]">
                          <img
                            src={botLogo}
                            alt="bot logo"
                            className="w-[24px] h-[24px] invert"
                          />
                        </div>
                        <div className="flex flex-col items-center justify-center opacity-70 px-3 pt-3 pb-2 bg-white text-black text-sm font-semibold rounded-r-lg rounded-bl-lg shadow-lg">
                          <p>Almost there... your answer is being generated.</p>
                          <ThreeDotsLoader className="animate-pulse" />
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            <div ref={messagesEndRef} />
          </div>
        </div>
        <div className="absolute bottom-0 left-[20px] right-[20px] mb-[16px] z-10 pointer-events-none">
          <div className="flex flex-col relative w-full h-[64px] bg-white/95 rounded-[14px] border-t-[0.8px] border-[#E2E8F0] shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),0_10px_15px_-3px_rgba(0,0,0,0.1)] pt-[10px] px-[16px] box-border shrink-0 pointer-events-auto">
            <div className="flex flex-row items-center w-full h-[42px] gap-[4px]">
              <button
                onClick={handleMicClick}
                className="flex items-center justify-center border-r-[2px] border-[#969696] hover:bg-gray-100 transition-colors shrink-0"
                style={{ width: "36px", height: "36px" }}
              >
                {isListening ? (
                  <SettingsVoiceIcon sx={{ color: "#FE7F20", width: 24, height: 24 }} />
                ) : (
                  <img src={micIconPng} alt="Mic" className="w-[20px] h-[20px] object-contain" />
                )}
              </button>

              <button
                onClick={handleButtonClick}
                className="flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors shrink-0"
                style={{ width: "36px", height: "36px" }}
              >
                <img src={uploadIconPng} alt="Upload" className="w-[20px] h-[20px] object-contain" />
              </button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              {showSuggestions && suggestions.length > 0 && (
                <div className="absolute bottom-full mb-2 left-[100px] z-40 max-w-full bg-white shadow-md border rounded-lg">
                  <ul className="flex flex-col py-2">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        className="px-4 py-1.5 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
                        onClick={() => handleTranslationClick(suggestion)}
                      >
                        <span>{suggestion}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <input
                placeholder={
                  Translation[selectedLanguageCode]?.searchPlaceholder ||
                  "Type your query here or press mic for audio communication"
                }
                value={searchText}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                className="flex-1 h-[42px] px-[14px] py-[10px] border-[1.2px] border-[#E2E8F0] rounded-[10px] bg-[#F8FAFC] placeholder-[#90A1B9] text-[14px] leading-none tracking-normal font-normal text-[#333333] focus:outline-none focus:border-[#F97316]"
                style={{ fontFamily: 'Inter, sans-serif' }}
              />

              <button
                className={`flex items-center justify-center w-[42px] h-[42px] transition-opacity shrink-0 relative ${loading ? "opacity-50" : "hover:opacity-80"}`}
                onClick={handleSearch}
                disabled={loading || !searchText}
              >
                <img src={sendButtonPng} alt="Send" className="w-[56px] h-[56px] max-w-none absolute -top-[4px] -left-[7px] object-contain" />
              </button>
            </div>
          </div>
        </div>
        {isListOpen && (
          <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-1/2 h-[80%] overflow-auto ">
              <h2 className="text-lg font-bold mb-4">Select a Table</h2>
              <ul>
                {Object.entries(
                  chatbotOutput[outputIndex]?.grievance_bucket,
                ).map(([key, value], index) => (
                  <li
                    key={index}
                    className="py-2 px-4 hover:bg-gray-200 cursor-pointer rounded"
                    onClick={() => handleSelectedBucket(value)}
                  >
                    {/* {key} */}
                    <table className="min-w-full mt-2 text-sm border-collapse border border-gray-300">
                      <tbody>
                        {Object.entries(value).map(([key, value], index) => (
                          <tr
                            key={index}
                            className={
                              index % 2 === 0 ? "bg-[#d1d8dc]" : "bg-[white]"
                            }
                          >
                            <td className="border border-gray-400 px-4 py-2 font-medium text-gray-800 w-[30%] ">
                              {key}
                            </td>
                            <td className="border border-gray-400 px-4 py-2 text-gray-800 w-[70%] ">
                              {typeof value === "object"
                                ? JSON.stringify(value)
                                : value}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </li>
                ))}
              </ul>
              <button
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                onClick={togglePopup}
              >
                Close
              </button>
            </div>
          </div>
        )}
        {isPopupOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <h2 className="text-lg font-semibold mb-4">User Feedback</h2>

              <label htmlFor="feedback" className="block mb-2 text-gray-700">
                Your Feedback
              </label>
              <textarea
                id="feedback"
                value={feedback}
                onChange={handleFeedbackChange}
                rows="4"
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>

              <div className="flex justify-end mt-4">
                <button
                  onClick={closePopup}
                  className="px-4 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {fileLoading && <ScreenLoader />}
      {submitLoading && <ScreenLoader />}
    </>
  );
};

export default FAQ;
